import React from 'react';

import {Image} from '@udemy/react-core-components';
import {useUDData, useUDLink} from '@udemy/ud-data';

import styles from './image-banner.module.less';

interface ImageBannerProps {
    sourceObjectId: number;
}

export const ImageBanner = ({sourceObjectId}: ImageBannerProps) => {
    const {Config} = useUDData();
    const udLink = useUDLink();

    const mobileImageSrc = udLink.toStorageStaticAsset(
        `consumer-subscription/window-shopping/mobile/${sourceObjectId}.png`,
        {Config},
    );
    const desktopImageSrc = udLink.toStorageStaticAsset(
        `consumer-subscription/window-shopping/desktop/${sourceObjectId}.jpg`,
        {Config},
    );
    const desktopImageSrc2x = udLink.toStorageStaticAsset(
        `consumer-subscription/window-shopping/desktop/${sourceObjectId}-2x.jpg`,
        {Config},
    );

    return (
        <div className={styles['image-container']}>
            <Image
                className={`${styles['banner-image']} ${styles['on-mobile']}`}
                data-purpose="mobile-banner"
                width="unset"
                height="unset"
                src={mobileImageSrc}
                alt=""
            />
            <Image
                className={`${styles['banner-image']} ${styles['on-desktop']}`}
                data-purpose="desktop-banner"
                width="unset"
                height="unset"
                src={desktopImageSrc}
                srcSet={`${desktopImageSrc} 1x, ${desktopImageSrc2x} 2x`}
                alt=""
            />
        </div>
    );
};
